import { render, staticRenderFns } from "./InquiryOpinionPopup.vue?vue&type=template&id=eb2820fa&"
import script from "./InquiryOpinionPopup.vue?vue&type=script&lang=js&"
export * from "./InquiryOpinionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports